<template>
  <div style=" width: 100%; height: 100%;">
    <div class="passcode-div">
      <div class="passcode-content">
        <!--<div class="passcode-logo"></div>-->
        <div class="passcode-form">
          <el-form label-position="top">
            <el-form-item style="margin-bottom: 0;">
              <div class="passcode-logo">
                <span class="passcode-span"><i class="el-icon-info" style="margin-right: 12px;"></i>输入提取码，即可查看文件～</span>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="passcode-input">
                <el-form :inline="true" style="width: 450px;">
                  <el-form-item style="margin-bottom: 0;">
                    <el-input type="password" clearable placeholder="请输入提取码" style="margin-right: 12px;" v-model="passCode"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-bottom: 0;">
                    <el-button type="primary" style="background-color: #4972C0;border-color: #4972C0;" @click="getFile">提取文件</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="login-foot foot">
      <foot></foot>
    </div>
  </div>
</template>
<script>
import ct from '../../utils/constant.js'
import foot from '../../components/Footer.vue'
export default {
  created () {
    this.initData()
  },
  data () {
    return {
      passCode: '',
      shareId: ''
    }
  },
  components: {
    foot
  },
  methods: {
    getFile () {
      if (this.passCode === '') {
        this.$message({message: '请输入提取码～', type: 'error'})
        return
      }
      if (!this.shareId) {
        return
      }
      this.uploadFileRequest('share?id=' + this.shareId + '&password=' + this.passCode, null).then(res => {
        // console.log('share')
        if (res.data.code === 0) {
          this.$router.push({name: ct.RouterData.shared.name, query: {id: this.shareId, flag: ct.UrlFlag.fromShare}, params: {passCode: this.passCode, updateCode: Math.random() * 1000}})
        }
      })
    },
    initData () {
      let r = this.$route.query
      if (r) {
        this.shareId = r.id
      }
    }
  }
}
</script>
<style>
  .passcode-div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .passcode-content {
    width: 550px;
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .passcode-logo {
    width: 550px;
    height: 100px;
    background-color: #4972C0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    justify-content: center;
    display: flex;
    align-items: center;
  }

  .passcode-span {
    color: #ffffff;
    font-size: 18px;
    font-weight: 800;
  }

  .passcode-input {
    width: 548px;
    height: 250px;
    border: 1px solid gainsboro;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/share/InputPassCode.vue